import { AiFillHome } from "react-icons/ai";
import { GiWaterBottle } from "react-icons/gi";
import { RiCustomerService2Fill } from "react-icons/ri";
import { HiBuildingOffice2 } from "react-icons/hi2";
import { BsImageAlt } from "react-icons/bs";

export const links = [
  { name: "home", to: "#home", icon: <AiFillHome /> },
  { name: "products", to: "#products", icon: <GiWaterBottle /> },
  { name: "gallery", to: "#gallery", icon: <BsImageAlt /> },
  { name: "about", to: "#about", icon: <HiBuildingOffice2 /> },
  { name: "contact", to: "#contact", icon: <RiCustomerService2Fill /> },
];
